/**
 * Harvest Roles Matrix — admin panel access for staff roles.
 * @see Harvest Roles Matrix.xlsx
 */

export const STAFF_ROLES = ['financeManager', 'complianceOfficer', 'marketingSpecialist', 'supportAgent'];

/** Roles allowed to sign in to the admin panel. */
export const ADMIN_PANEL_LOGIN_ROLES = ['superAdmin', 'admin', ...STAFF_ROLES];

/**
 * URL prefixes each limited role may open.
 * Staff also get Fund Managers + Investors where noted; Subscription for finance/compliance.
 */
export const ROLE_ALLOWED_PATH_PREFIXES = {
  financeManager: [
    '/deals',
    '/reports',
    '/fund-managers-list',
    '/investors-list',
    '/subscription',
    '/messages',
    '/profile',
    '/unauthorized'
  ],
  complianceOfficer: [
    '/deals',
    '/reports',
    '/documents',
    '/crm',
    '/fund-managers-list',
    '/investors-list',
    '/subscription',
    '/messages',
    '/profile',
    '/unauthorized'
  ],
  marketingSpecialist: [
    '/dashboard',
    '/reports',
    '/Announcements',
    '/announcements',
    '/crm',
    '/fund-managers-list',
    '/investors-list',
    '/messages',
    '/profile',
    '/unauthorized'
  ],
  supportAgent: ['/support', '/deals', '/messages', '/profile', '/unauthorized']
};

export const ROLE_DEFAULT_LANDING = {
  financeManager: '/reports',
  complianceOfficer: '/deals',
  marketingSpecialist: '/dashboard',
  supportAgent: '/support',
  admin: '/dashboard',
  superAdmin: '/dashboard'
};

export function canAccessPath(role, pathname) {
  if (!role) return false;
  if (role === 'superAdmin' || role === 'admin') return true;

  const prefixes = ROLE_ALLOWED_PATH_PREFIXES[role];
  if (!prefixes) return false;

  const path = (pathname || '/').split('?')[0];

  if (path === '/' || path === '/dashboard') {
    return prefixes.some((p) => p === '/dashboard' || p === '/');
  }

  return prefixes.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export function getLandingPath(role) {
  return ROLE_DEFAULT_LANDING[role] || '/dashboard';
}

/** Whether role may see a menu item id (optional helper). */
export function roleHasMenuAccess(role, allowedRoles = []) {
  if (!role || !allowedRoles.length) return false;
  if (role === 'superAdmin' || role === 'admin') return true;
  return allowedRoles.includes(role);
}
